import View from './view'
import {combineStates, context, reducer} from "../../../../support/join_contexts_HOC";
import {component_reducer, dispatchToProps, initState} from "./local_state/reducer";
import {JoinedTypePropsType, OwnPropsType, SearchModesType} from "./index.types";
import {EventPropsType, InputPropsType} from "./view.types";
import Network from "../../../../support/network";
import {
    getFilmsFilmaRequest,
    getFilmsImdbFilmaRequest,
    getFilmsImdbRequest
} from "../../../../support/network/requests/google_search";
import {PopUpContext} from "../../../../support/pop_up";
import {PendingFilmType} from "../../../../models/pending_film";
import {GetFilmIdResultType} from "../../../../models/google_search";

export const mapProps = (ownProps: OwnPropsType & JoinedTypePropsType): InputPropsType => ({
    processResult: ownProps.reducer.processResult,
    currentPendingFilm: ownProps.pending_film
})

export const mapEvents = (ownProps: OwnPropsType & JoinedTypePropsType): EventPropsType => ({
    searchIds: async (searchTerm: string, mode: SearchModesType = 'both') => {
        const onSuccess = (res: GetFilmIdResultType) => {
            console.log('res')
            console.log(res)
            let results = ownProps.reducer.processResult
            switch (mode) {
                case "both":
                    results = res
                    break;
                case "filmaffinity":
                    results = {...results, filmaffinity: res.filmaffinity}
                    break;
                case "imdb":
                    results = {...results, imdb: res.imdb}
                    break;
            }
            ownProps.reducer.setProcessResult(results)
        }
        const onFailure =(error: any) => {
            if (error.status === 429) {
                alert('See you tomorrow. Don\'t forget to download the results')
            }
        }
        switch (mode) {
            case "both":
                Network.instance.netClient.executeRequest(getFilmsImdbFilmaRequest(searchTerm, onSuccess, onFailure))
                break;
            case "filmaffinity":
                Network.instance.netClient.executeRequest(getFilmsFilmaRequest(searchTerm, onSuccess, onFailure))
                break;
            case "imdb":
                Network.instance.netClient.executeRequest(getFilmsImdbRequest(searchTerm, onSuccess, onFailure))
                break;
        }
    },
    submitPendingFilm: (film: PendingFilmType) => {
        ownProps.onPendingFilmReviewed(film)
    },
    skip: () => {
        ownProps.onSkip()
    },
})

export default combineStates<JoinedTypePropsType, OwnPropsType, InputPropsType, EventPropsType>(View, mapProps, mapEvents, [
    reducer.createComponent('reducer', component_reducer, initState, dispatchToProps),
    context.createComponent('popUp', PopUpContext)
])
